<div class="list-card">
  <div class="list-card__toolbar">
    <div class="list-card__search">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.75" />
        <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
      </svg>
      <input type="search" placeholder="Search..." disabled />
    </div>
    <button type="button" class="btn btn-primary" disabled>Add new</button>
  </div>

  <div class="list-card__table-wrap">
    <table class="list-card__table">
      <thead>
        <tr>
          @for (col of columns(); track col.key) {
            <th [style.width]="col.width || 'auto'">{{ col.label }}</th>
          }
          <th class="list-card__actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (row of [].constructor(rowCount()); track $index) {
          <tr class="list-card__skeleton-row" aria-hidden="true">
            @for (col of columns(); track col.key) {
              <td><span class="list-card__skeleton"></span></td>
            }
            <td><span class="list-card__skeleton list-card__skeleton--sm"></span></td>
          </tr>
        }
      </tbody>
    </table>

    <div class="list-card__empty">
      <div class="list-card__empty-icon" aria-hidden="true">◇</div>
      <h3>{{ emptyTitle() }}</h3>
      <p>{{ emptyMessage() }}</p>
    </div>
  </div>
</div>
